import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import PopularHotels from "../Hotels/Component/PopularHotels";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import FlightsWidgit from "../FlightsWidgit";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";

function App1() {
  return (
   <>

 <Helmet>
  <title>Top Travel Destinations Around the World | Explore & Book Now - cheapflightsprices.com</title>
  <meta name="description" content="Discover the top travel destinations across the globe. Explore stunning locations, get travel tips, and book affordable flights with cheapflightsprices.com." />
  <meta name="keywords" content="Top travel destinations, best places to visit, cheap flights, explore destinations, travel ideas, international trips, holiday destinations, cheapflightsprices" />
  
  <meta property="og:title" content="Top Travel Destinations Around the World | Explore & Book Now" />
  <meta property="og:description" content="Explore stunning global travel destinations and book affordable flights online at cheapflightsprices.com. Your perfect vacation starts here!" />
  <meta property="og:site_name" content="cheapflightsprices.com" />
  
  <meta name="twitter:title" content="Top Travel Destinations | Book Affordable Flights" />
  <meta name="twitter:description" content="Discover the world’s most visited and loved travel destinations. Book your flight now with cheapflightsprices.com" />
  
  <link rel="canonical" href="https://cheapflightsprices.com/top-destinations" />
</Helmet>



   <section id="banner_section">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Top Travel Destinations</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
      
    </div>
  </section>
<Badge/>


    <main id="main">
    <section id="Cheapflights" className="section-with-bg">
    <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><strong>Top Travel Destinations</strong></h2>
          <p></p>
        </div>
      <div className="top-destinations-page">
  <h2>Top Travel Destinations</h2>
  <p>Dreaming of your next getaway? Whether you're looking for adventure, relaxation, culture, or food, these top travel destinations around the world offer unforgettable experiences. Explore these places and start planning your next journey with unbeatable flight deals from cheapflightsprices.com.</p>

  <h2>Popular Destinations to Explore</h2>

  <h3>Paris, France</h3>
  <p>The City of Light is a timeless favorite. Enjoy the Eiffel Tower, world-class museums like the Louvre, romantic Seine River cruises, and delicious French pastries.</p>

  <h3>Bali, Indonesia</h3>
  <p>From lush jungles and serene rice terraces to beachside resorts and vibrant culture, Bali offers the perfect blend of nature and spirituality.</p>

  <h3>New York City, USA</h3>
  <p>The city that never sleeps dazzles with iconic landmarks like Times Square, Central Park, and the Statue of Liberty. Enjoy Broadway shows and diverse cuisines from around the globe.</p>

  <h3>Tokyo, Japan</h3>
  <p>Experience a unique fusion of tradition and technology in Tokyo. From ancient temples to neon-lit skyscrapers and sushi to street fashion, it’s a cultural explosion.</p>

  <h3>Dubai, UAE</h3>
  <p>Luxury, innovation, and adventure come together in Dubai. Explore the Burj Khalifa, desert safaris, man-made islands, and world-class shopping experiences.</p>

  <h3>Rome, Italy</h3>
  <p>Step into history as you explore ancient ruins like the Colosseum and Roman Forum, all while indulging in Italy’s finest pasta and gelato.</p>

  <h3>Sydney, Australia</h3>
  <p>Known for its harbor, Opera House, and beaches, Sydney is perfect for outdoor lovers and culture seekers alike.</p>

  <h3>Cape Town, South Africa</h3>
  <p>With its stunning coastal scenery, Table Mountain views, vineyards, and diverse wildlife, Cape Town is a top destination for adventure and relaxation.</p>

  <h3>Santorini, Greece</h3>
  <p>Whitewashed buildings with blue domes overlooking the Aegean Sea make Santorini a dream destination for honeymooners and island lovers.</p>

  <h3>London, UK</h3>
  <p>From Buckingham Palace and the London Eye to street markets and historic pubs, London offers a mix of royal tradition and modern flair.</p>

  <h2>Start Your Journey Today</h2>
  <p>At <strong>cheapflightsprices.com</strong>, we help you compare flight prices and find the best deals to these amazing destinations. Book now and turn your travel dreams into reality.</p>
</div>
      </div>
    </section>
    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
    <FlightsFrom/>
    
    <Faqs/>
    <Newsletter/>
    
      </main>
  
    </>
  );
}
export default App1;
